import { Box, Skeleton, Stack } from "@chakra-ui/react";

/**
 * A table's shape while its rows are on the way.
 *
 * A line of text saying "Loading…" tells somebody to wait without telling them
 * what for, and the page jumps when the real thing arrives at a different
 * height. This holds roughly the right space and reads as a table, so the
 * arrival is a fill rather than a jolt.
 */
export function TableSkeleton({ rows = 8, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <Box borderWidth="1px" borderColor="border" p={4}>
      <Stack gap={3}>
        {Array.from({ length: rows }, (_, rowIndex) => (
          <Stack key={rowIndex} direction="row" gap={4} align="center">
            {Array.from({ length: columns }, (_, columnIndex) => (
              <Skeleton
                key={columnIndex}
                height="4"
                flex={columnIndex === 0 ? "2" : "1"}
                // The header row reads a shade stronger than the body, the way
                // the real one does.
                opacity={rowIndex === 0 ? 1 : 0.6}
              />
            ))}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
